import { Wrench, Zap, HardHat, Hammer, Leaf, Car, Store } from "lucide-react";
import { Reveal } from "./Reveal";

const TRADES = [
    { name: "Plumbers", icon: Wrench },
    { name: "Electricians", icon: Zap },
    { name: "Builders", icon: HardHat },
    { name: "Roofers", icon: Hammer },
    { name: "Landscapers", icon: Leaf },
    { name: "Mechanics", icon: Car },
    { name: "Other Small Businesses", icon: Store },
];

const IMG_BUILDER =
    "https://images.unsplash.com/photo-1646324554833-f0b6a479fa5d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwxfHxidWlsZGVyJTIwY3JhZnRzbWFuJTIwd29ya2luZyUyMG9uJTIwc2l0ZXxlbnwwfHx8fDE3OTE0NjE5NDR8MA&ixlib=rb-4.1.0&q=85";
const IMG_MECHANIC =
    "https://images.unsplash.com/photo-1615906655593-ad0386982a0f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwxfHxtZWNoYW5pYyUyMHdvcmtzaG9wJTIwcmVwYWlyaW5nJTIwdmVoaWNsZXxlbnwwfHx8fDE3OTE0NjE5NDR8MA&ixlib=rb-4.1.0&q=85";

export const WhatWeDo = () => (
    <section
        id="what-we-do"
        data-testid="what-we-do-section"
        className="bg-[#FAFAFA] py-24 lg:py-32"
    >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid lg:grid-cols-12 gap-14 lg:gap-20 items-start">
                <div className="lg:col-span-6">
                    <Reveal>
                        <p className="font-mono-label text-xs font-medium tracking-[0.25em] uppercase text-blue-600 mb-5">
                            What We Do
                        </p>
                        <h2 className="text-3xl sm:text-4xl font-bold tracking-tight text-zinc-950 leading-tight">
                            Professional websites, without the fuss.
                        </h2>
                    </Reveal>
                    <Reveal delay={0.12}>
                        <p className="mt-6 text-base sm:text-lg text-zinc-600 leading-relaxed max-w-xl">
                            We design and build modern, mobile-friendly websites that
                            give your business a professional online presence — clear,
                            fast and easy for your customers to use.
                        </p>
                    </Reveal>
                    <Reveal delay={0.2}>
                        <p className="mt-8 font-mono-label text-xs tracking-widest uppercase text-zinc-500 mb-4">
                            Who we build for
                        </p>
                        <div className="flex flex-wrap gap-2.5" data-testid="trade-category-list">
                            {TRADES.map(({ name, icon: Icon }) => (
                                <span
                                    key={name}
                                    data-testid={`trade-category-badge-${name.toLowerCase().replace(/\s+/g, "-")}`}
                                    className="inline-flex items-center gap-2 rounded-full border border-zinc-200 bg-white px-4 py-2 text-sm font-medium text-zinc-700 transition-colors duration-200 hover:border-blue-600 hover:text-blue-700"
                                >
                                    <Icon size={15} className="text-blue-600" />
                                    {name}
                                </span>
                            ))}
                        </div>
                    </Reveal>
                </div>

                <div className="lg:col-span-6 grid grid-cols-2 gap-5">
                    <Reveal delay={0.1} className="mt-10">
                        <div className="rounded-2xl overflow-hidden aspect-[3/4]">
                            <img
                                src={IMG_BUILDER}
                                alt="Craftsman builder working on a timber frame structure"
                                className="w-full h-full object-cover transition-transform duration-700 hover:scale-105"
                                data-testid="what-we-do-image-builder"
                            />
                        </div>
                    </Reveal>
                    <Reveal delay={0.22}>
                        <div className="rounded-2xl overflow-hidden aspect-[3/4] border-4 border-blue-600/15">
                            <img
                                src={IMG_MECHANIC}
                                alt="Mechanic servicing a vehicle engine in a workshop"
                                className="w-full h-full object-cover transition-transform duration-700 hover:scale-105"
                                data-testid="what-we-do-image-mechanic"
                            />
                        </div>
                    </Reveal>
                </div>
            </div>
        </div>
    </section>
);
